import { useNavigate } from 'react-router'
import UserSettings from '../../pages/UserSettings'
import { useSettings } from '../../hooks/useSettings'
import { useInitialization } from '../../contexts/Initialization'
import { CHANGE_PASSWORD, DISABLE_MFA, SETTINGS } from '../../constants/routes'
import { getInitialSettings } from '../../utils/getInitialSettings'

function UserSettingsWrapper() {
  const navigate = useNavigate()
  const { user, siteKey } = useInitialization() || {}
  const settings = useSettings(getInitialSettings(user))
  const {
    isLocalLoginEnabled,
    enabledMFAMechanisms,
    mfaEnforced,
    hasMFAEnabled,
    isMFASetupInProgress,
    recoveryOTPRegisterErrorCode,
    revokeMFAErrorCode,
    mfaToRevoke,
    isMFARevokeInProgress,
    isSuccessfullyRevoked,
    recoveryCodeList,
    isPasswordSetupInProgress,
    hasAllMFAEnabled,
    setupMfa,
    renewRecoveryCodes,
    selectMFAToRevoke,
    dismissRevokeConfirmation,
  } = settings

  const mfaSettings = {
    enabledMFAMechanisms,
    mfaEnforced,
    hasMFAEnabled,
    isMFASetupInProgress,
    recoveryOTPRegisterErrorCode,
    revokeMFAErrorCode,
    mfaToRevoke,
    isMFARevokeInProgress,
    isSuccessfullyRevoked,
    recoveryCodeList,
    hasAllMFAEnabled,
  }

  const passwordSettings = {
    isPasswordSetupInProgress,
    errorCode: null,
  }

  const mfaActions = {
    onSetupMFA: () => setupMfa({ isFromSettings: true }),
    onSetupMFAMechanism: (target) =>
      navigate(target, { state: { isFromSettings: true } }),
    onRecoveryCodesRenew: renewRecoveryCodes,
    onRecoveryCodesRenewConfirm: () => navigate(SETTINGS),
    onDismissMFAMechanismConfirm: dismissRevokeConfirmation,
    onSelectMFAToRevoke: (mfaToRevokeVal) => selectMFAToRevoke(mfaToRevokeVal),
    goToDisableMFAPage: (mfaToRevoke) =>
      navigate(DISABLE_MFA, { state: { mfaToRevoke } }),
  }

  const passwordActions = {
    goToChangePasswordPage: () => navigate(CHANGE_PASSWORD),
  }

  return (
    <UserSettings
      user={user}
      siteKey={siteKey || ''}
      isLocalLoginEnabled={isLocalLoginEnabled}
      mfaSettings={mfaSettings}
      passwordSettings={passwordSettings}
      mfaActions={mfaActions}
      passwordActions={passwordActions}
    />
  )
}

export default UserSettingsWrapper
